// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M13.5 4C13.5 3.6585 13.5311 3.32428 13.5907 3H4V22.9432L12 17.2289L20 22.9432V9.40931C19.6757 9.46888 19.3415 9.5 19 9.5C15.9624 9.5 13.5 7.03757 13.5 4Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23 3H15V5H23V3Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-bookmark-minus-filled')
export default class BookmarkMinusFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'bookmark-minus-filled',
    }
  }
}
